import gsap from "gsap";

export const navListSelector = 'header[data-header="full"] #header-work-heading + .header__nav-list';
let shuffledPreviewOrder: string[] | null = null;

export function applyHeroOrder(root: HTMLElement) {
    const sliderEl = root.querySelector<HTMLElement>(".hero__bg-slider");
    if (sliderEl) shuffleSlides(sliderEl, root);
}

export function shuffleSlides(sliderEl: HTMLElement, root: HTMLElement) {
    const allSlides = Array.from(sliderEl.querySelectorAll<HTMLElement>(".hero__bg-slide"));
    if (allSlides.length < 2) return;

    const slideContainer = allSlides[0]?.parentElement ?? sliderEl;
    const defaultSlide = allSlides.find(slide => slide.dataset.heroPreview === "default") ?? null;
    const nonDefault = allSlides.filter(slide => slide.dataset.heroPreview !== "default");

    const byPreview = new Map(nonDefault.map(slide => [slide.dataset.heroPreview ?? "", slide]));
    let shuffled = (shuffledPreviewOrder ?? []).map(id => byPreview.get(id)).filter((slide): slide is HTMLElement => Boolean(slide));

    if (shuffled.length !== nonDefault.length) {
        shuffled = gsap.utils.shuffle(nonDefault);
        shuffledPreviewOrder = shuffled.map(slide => slide.dataset.heroPreview!);
    }

    if (defaultSlide) slideContainer.appendChild(defaultSlide);
    shuffled.forEach(slide => slideContainer.appendChild(slide));

    const navListEl = root.querySelector<HTMLElement>(navListSelector);
    if (!navListEl) return;

    const liByPreview = new Map<string, Element>();
    navListEl.querySelectorAll<HTMLAnchorElement>("a[data-hero-preview]").forEach(link => {
        const li = link.closest("li");
        if (link.dataset.heroPreview && li) liByPreview.set(link.dataset.heroPreview, li);
    });

    const order = shuffled.map(slide => slide.dataset.heroPreview!);
    let orderIndex = 0;
    Array.from(navListEl.children)
        .map(li => (li.querySelector("a[data-hero-preview]") ? (liByPreview.get(order[orderIndex++] ?? "") ?? li) : li))
        .forEach(li => navListEl.appendChild(li));
}
